import RetailerShopCard from '../../components/retailer-shop/ShopCard'
import BackButtonAndTitle from '../../components/retailer-shop/BackButtonAndTitle'
import DocumentsSection from '../../components/retailer-shop/DocumentsSection'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { useAuth } from '../../contexts/AuthContext'

const ShopPage = () => {
  const { currentUser } = useAuth()
  const { data: shopDataRequest } = useQuery({
    queryKey: QueryKeys.myShopDetails(currentUser.userType),
    queryFn: () => handleGetRequest(`${currentUser.userType}s/my-shop`),
    staleTime: 1000,
  })

  return (
    <div className="main-container min-h-screen">
      <BackButtonAndTitle title="View Shop" navigateTo="/" />

      <div className="grid grid-cols-1 lg:grid-cols-2  gap-6">
        <RetailerShopCard shopData={shopDataRequest?.data} styleClass="w-full" editable={true} />
        <div className="w-full">
          <h2 className="text-lg font-semibold mb-4">Shop Documents</h2>
          <DocumentsSection readOnly />
        </div>
      </div>
    </div>
  )
}

export default ShopPage
